import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';

const ServiziOfferti = () => {
  const { t } = useTranslation();

  return (
    <div className="servizi-offerti-page">
      <div className="top-bar" />

      <section className="servizi-hero">
        <h1 className="servizi-main-title">{t('serviziOfferti.mainTitle')}</h1>
      </section>

      <section className="servizio-section coppia-section">
        <div className="servizio-container">
          <h2 className="servizio-title">{t('serviziOfferti.coppiaTitle')}</h2>
          <div className="servizio-content">
            <p>{t('serviziOfferti.coppiaP1')}</p>
            <p>{t('serviziOfferti.coppiaP2')}</p>
            <p className="servizio-closing">{t('serviziOfferti.coppiaClosing')}</p>
          </div>
        </div>
      </section>

      <section className="servizio-section donna-section">
        <div className="servizio-container">
          <h2 className="servizio-title">{t('serviziOfferti.donnaTitle')}</h2>
          <div className="servizio-content">
            <p>{t('serviziOfferti.donnaP1')}</p>
            <p>{t('serviziOfferti.donnaP2')}</p>
            <p>{t('serviziOfferti.donnaP3')}</p>
            <p className="servizio-closing">{t('serviziOfferti.donnaClosing')}</p>
          </div>
        </div>
      </section>

      <section className="servizio-section uomo-section">
        <div className="servizio-container">
          <h2 className="servizio-title">{t('serviziOfferti.uomoTitle')}</h2>
          <div className="servizio-content">
            <p>{t('serviziOfferti.uomoP1')}</p>
            <Link to="/contatti" className="whatsapp-btn" data-testid="contattami-btn">
              <Mail size={22} />
              <span>{t('serviziOfferti.contactBtn')}</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiziOfferti;
